export type PlaceholderItem = {
    category: string
    placeholder: string
    label: string
    labelExtended?: string
}

export type PlaceholderCategory = {
    category: string
    items: Array<{ placeholder: string; label: string; labelExtended?: string }>
}

export type GroupedPlaceholderItems = PlaceholderCategory[]

const placeholderData: GroupedPlaceholderItems = [
    {
        category: 'Candidat',
        items: [
            { placeholder: '[cnd:civilite] [cnd:prenom] [cnd:nom]', label: 'Identité complète', labelExtended: 'Identité complète du candidat' },
            { placeholder: '[cnd:civilite]', label: 'Civilité', labelExtended: 'Civilité du candidat' },
            { placeholder: '[cnd:prenom]', label: 'Prénom', labelExtended: 'Prénom du candidat' },
            { placeholder: '[cnd:nom]', label: 'Nom', labelExtended: 'Nom du candidat' },
            { placeholder: '[cnd:qualification]', label: 'Poste recherché', labelExtended: 'Poste recherché du candidat' },
            { placeholder: '[cnd:tel_mobile]', label: 'Téléphone mobile', labelExtended: 'Téléphone mobile du candidat' },
            { placeholder: '[cnd:tel_fixe]', label: 'Téléphone fixe', labelExtended: 'Téléphone fixe du candidat' },
            { placeholder: '[cnd:adresse]', label: 'Adresse', labelExtended: 'Adresse complète du candidat' },
            { placeholder: '[cnd:email]', label: 'Email', labelExtended: 'Email du candidat' },
            { placeholder: '[cnd:compte_rendu]', label: "Dernier compte-rendu d'entretien" }
        ]
    },
    {
        category: 'Contact',
        items: [
            { placeholder: '[ct:civilite] [ct:prenom] [ct:nom]', label: 'Identité complète', labelExtended: 'Identité complète du contact' },
            { placeholder: '[ct:civilite]', label: 'Civilité', labelExtended: 'Civilité du contact' },
            { placeholder: '[ct:prenom]', label: 'Prénom', labelExtended: 'Prénom du contact' },
            { placeholder: '[ct:nom]', label: 'Nom', labelExtended: 'Nom du contact' }
        ]
    },
    {
        category: 'Commande',
        items: [
            { placeholder: '[order:qualification]', label: 'Qualification', labelExtended: 'Qualification de la commande' }
        ]
    },
    {
        category: 'Entreprise',
        items: [
            { placeholder: '[ent:raison_sociale]', label: 'Raison sociale', labelExtended: 'Raison sociale de l\'entreprise' },
            { placeholder: '[ent:adresse]', label: 'Adresse', labelExtended: 'Adresse complète de l\'entreprise' },
            { placeholder: '[ent:telephone]', label: 'Téléphone', labelExtended: 'Téléphone de l\'entreprise' }
        ]
    },
    {
        category: 'GDPR',
        items: [
            { placeholder: '[consentement-ok]', label: 'URL consentement' },
            { placeholder: '[consentement-nok]', label: 'URL refus' }
        ]
    },
    {
        category: 'Autres',
        items: [
            { placeholder: '[signature]', label: 'Signature' }
        ]
    }
]

export const getPlaceholderData = ({
    categoriesFilter,
    itemsFilter
}: {
    categoriesFilter?: string[]
    itemsFilter?: string[]
}) => {
    let filteredData = placeholderData
    if (categoriesFilter) {
        filteredData = filteredData.filter((category) => categoriesFilter.includes(category.category))
    }
    if (itemsFilter) {
        filteredData = filteredData.map((category) => ({
            ...category,
            items: category.items.filter((item) => itemsFilter.includes(item.placeholder))
        }))
    }

    return filteredData
}
